export { default } from './auth';
export type { AuthConfig } from './auth.interfaces';
